import script from "./article.vue?vue&type=script&setup=true&lang=js"
export * from "./article.vue?vue&type=script&setup=true&lang=js"

import "./article.vue?vue&type=style&index=0&id=369e9f2c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369e9f2c"]])

export default __exports__